import React from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";

function useAluminumColorSelector() {
  const addToQuote = useStore((state) => state.addToQuote);

  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);

  const doorType = useStore((state) => state.quote.doorType);

  const aluminumColor = useStore((state) => state.quote.aluminumColor);
  const splitFinish = useStore((state) => state.quote.splitFinish);
  const aluminumColorExterior = useStore(
    (state) => state.quote.aluminumColorExterior
  );

  const customCladColor = useStore((state) => state.quote.customCladColor);
  const customCladColorExterior = useStore(
    (state) => state.quote.customCladColorExterior
  );

  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const { value } = event.target;
    if (value.length <= 20) {
      addToQuote({ [type]: value }, type);

      const reqKey = "Custom Clad Color";

      if (findRequired(reqKey)) removeRequired(reqKey);
    }
  };

  const handleClick = (label: string, type: string) => {
    const disabled =
      type === "aluminumColorExterior"
        ? disabledExt(label)
        : disabledInt(label);
    if (disabled) return;

    const checked = checkMark(label, type);

    let update = {
      [type]: !checked ? label : ""
    }

    if(doorType?.includes("Bi-fold") && type === "aluminumColorExterior"){
      update["headTrackColor"] = checked ? "" : label
    }

    addToQuote(update, type);

    const reqKey =
      isSplit && type === "aluminumColorExterior"
        ? "Aluminum Color Exterior"
        : isSplit && type === "aluminumColor"
        ? "Aluminum Color Interior"
        : "Aluminum Color";

    if (!checked && findRequired(reqKey)) removeRequired(reqKey);
  };

  const handleClickSplit = (label: string) => {
    const checked = label === splitFinish;

    if (checked) {
      return addToQuote(
        {
          splitFinish: "",
          aluminumColor: "",
        },
        "splitFinish"
      );
    }

    addToQuote({ splitFinish: label }, "splitFinish");
  };

  const variant = (label: string, type: string) =>
    type === "aluminumColor" && label === aluminumColor
      ? "filled"
      : type === "aluminumColorExterior" && label === aluminumColorExterior
      ? "filled"
      : "outlined";

  const checkMark = (label: string, type: string) =>
    type === "aluminumColor"
      ? label === aluminumColor
      : label === aluminumColorExterior;

  const disabledInt = (label: string) =>
    !isSplit
      ? false
      : aluminumColorExterior?.includes("Custom")
      ? false
      : aluminumColorExterior === label;

  const disabledExt = (label: string) =>
    aluminumColor?.includes("Custom") ? false : aluminumColor === label;

  const isSplit = splitFinish === "Split Finish";

  const customClad = aluminumColor === "Custom Color (upcharge applies)";
  const customCladExt =
    aluminumColorExterior === "Custom Color (upcharge applies)";

  return {
    customClad,
    customCladExt,
    variant,
    checkMark,
    disabledExt,
    disabledInt,
    customCladColorExterior,
    handleClick,
    isSplit,
    handleChange,
    aluminumColorExterior,
    aluminumColor,
    customCladColor,
    handleClickSplit
  };
}

export default useAluminumColorSelector;
